import React from 'react';
import PropTypes from 'prop-types'
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText'
import { Link } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
const styles = theme => ({
  item: {
    display: 'flex'
  },
  link: {
    textDecoration: 'none'
  }
})
const DrawerItem = ({ classes, children, text, linkTo }) => (
  <ListItem className={classes.item}>
    <ListItemIcon>
      {children}
    </ListItemIcon>
    <Link className={classes.link} to={linkTo}>
      <ListItemText primary={text} />
    </Link>
  </ListItem>
);

DrawerItem.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.element,
  linkTo: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired
}
export default withStyles(styles)(DrawerItem);


// WEBPACK FOOTER //
// ./src/components/drawer-item.js